import React from 'react';

interface ModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteConfirmationModal: React.FC<ModalProps> = ({ isOpen, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-xl w-96">
        <h3 className="text-lg font-bold mb-4">Επιβεβαίωση Διαγραφής</h3>
        <p className="text-gray-600 mb-6">Είστε σίγουροι ότι θέλετε να διαγράψετε τα επιλεγμένα στοιχεία; Η ενέργεια αυτή δεν αναιρείται.</p>
        <div className="flex justify-end gap-3">
          <button onClick={onCancel} className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300">Άκυρο</button>
          <button onClick={onConfirm} className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700">Διαγραφή</button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;